import { AuthProvider } from "react-admin";
import { postJson } from "../../utils/api";

export const AUTH_TOKEN_KEY = "fez-admin-access-token";

class AuthProviderImpl implements AuthProvider {
  checkAuth(): Promise<void> {
    if (!localStorage.getItem(AUTH_TOKEN_KEY)) {
      return Promise.reject("unauthorized");
    }
    return Promise.resolve();
  }

  checkError(error: any): Promise<void> {
    const status = error?.status;
    if (status === 401 || status === 403) {
      localStorage.removeItem(AUTH_TOKEN_KEY);
      return Promise.reject("unauthorized");
    }
    return Promise.resolve();
  }

  getPermissions(): Promise<any> {
    return Promise.resolve(undefined);
  }

  login(params: any): Promise<any> {
    return postJson("/auth/google", {
      id_token: params?.access_token,
    })
      .then((resp) => resp.json())
      .then((payload) => {
        if (!payload.token || payload.token?.trim().length === 0) {
          throw "unauthorized";
        }
        localStorage.setItem(AUTH_TOKEN_KEY, payload.token);
      });
  }

  logout(): Promise<void | false | string> {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    return Promise.resolve();
  }
}

export default new AuthProviderImpl();
